import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { RootState } from '../../../../store';
import './../help-center.css';

interface IGrantAccessPrositeWidgetProps {
    onClose: () => void;
}

export const GrantAccessPrositeWidget = ({
    onClose,
}: IGrantAccessPrositeWidgetProps) => {
    return (
        <>
            <div className="box-collage-next">
                <button
                    className="boxes-btn"
                    onClick={() => {
                        onClose();
                    }}
                >
                    &lt;
                    <FormattedMessage id="Back" defaultMessage="Back" />
                </button>
                <h2>
                    <FormattedMessage
                        id="How_do_I_grant_employee_access"
                        defaultMessage="How do I grant employee access to the Prosite?"
                    />
                </h2>
                <div className="row">
                    <div className="col-sm-12">
                        <h3>
                            <FormattedMessage
                                id="Step_by_step_guide"
                                defaultMessage="Step by Step Guide"
                            />
                        </h3>
                        <ol className="ordered-list">
                            <li>
                                <FormattedMessage
                                    id="Hover_over_your_account_information"
                                    defaultMessage="Step 1. Hover over your account information at the top of the screen and select 'Managers Users'"
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="Select_Add_New_User"
                                    defaultMessage="Step 2. Select 'Add New User'"
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="Under_Add_New_User_fill_out"
                                    defaultMessage="Step 3. Under 'Add New User' fill out user information, Location access, Notification preferences and security access. Once complete hit 'Save User'"
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="After_hitting_Save_User_the_new_user"
                                    defaultMessage="Step 4. After hitting 'Save User' the new user will get an invitation to the prosite emailed to them and they will need to follow the link to get setup, the link is active for 48 hours"
                                />
                            </li>
                        </ol>
                    </div>
                    <div className="col-sm-12">
                        <p className="bottom-message-non-step">
                            <FormattedMessage
                                id="If_you_are_not_an_owner_master"
                                defaultMessage="If you are not an owner master you will need to call Starkey Customer Service at (800) 328-8602 and ask for the prosite team."
                            />
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state: RootState) => {
    return {};
};

const mapDispatchToProps = {};

const grantAccessPrositeWidgetContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(GrantAccessPrositeWidget);

export default grantAccessPrositeWidgetContainer;
